/**
 * External Imports
 */
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

/**
 * Internal Imports
 */
import ValidationProfile from './ValidationProfile';
import ReusableTabs from '../../components/reusableTabs';
import FeatureRoute from '../featureRoute/FeatureRoute';

// import { setTaskSearchQuery } from '../../redux';
import {
  clearAllDepts,
  clearUserSection,
  setUserSection
} from '../../redux/actions';

import { useFeatures } from '../../services/Features/features';
import NLRValidationList from './nlr/NLRValidationList';
import AIDETValidationList from './aidet/AIDETValidationList';
import BSSRValidationList from './bssr/BSSRValidationList';

const Validation: FC<{}> = () => {
  const dispatch = useDispatch();
  const {
    isNLRValidationEnabled,
    isAIDETValidationEnabled,
    isBSSRValidationEnabled
  } = useFeatures();
  const [searchTerm, setSearchTerm] = useState<string>('');

  // const view = useMemo(() => pathname.split('/')[2], [pathname]);

  const reusableTabItems = useMemo(
    () => ({
      base: '/validation',
      links: []
    }),
    []
  );

  useEffect(() => {
    dispatch(setUserSection('validation'));
    return () => {
      dispatch(clearAllDepts());
      dispatch(clearUserSection());
    };
  }, []);

  return (
    <div>
      {reusableTabItems.links.length > 0 && (
        <ReusableTabs tabItems={reusableTabItems} />
      )}
      <Routes>
        {/* NLR Validation Route */}
        <Route
          path="nlr/list"
          element={
            <FeatureRoute
              // TODO: Add List page with searchTerm and setSearchTerm once it's created
              component={
                <NLRValidationList
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              }
              isFeatureEnabled={isNLRValidationEnabled}
              offsetHeight={128}
            />
          }
        >
          <Route
            path=":validationFilter"
            element={
              <NLRValidationList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            }
          />
        </Route>
        {/* AIDET Validation Route */}
        <Route
          path="aidet/list"
          element={
            <FeatureRoute
              component={
                <AIDETValidationList
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              }
              isFeatureEnabled={isAIDETValidationEnabled}
              offsetHeight={128}
            />
          }
        >
          <Route
            path=":validationFilter"
            element={
              <AIDETValidationList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            }
          />
        </Route>

        {/* BSSR Validation Route */}
        <Route
          path="bssr/list"
          element={
            <FeatureRoute
              component={
                <BSSRValidationList
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              }
              isFeatureEnabled={isBSSRValidationEnabled}
              offsetHeight={128}
            />
          }
        >
          <Route
            path=":validationFilter"
            element={
              <BSSRValidationList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            }
          />
        </Route>

        {/* Profile and fallback */}
        <Route path="profile" element={<Outlet />}>
          <Route path=":validationType" element={<ValidationProfile />} />
        </Route>
        <Route
          path="*"
          element={
            <Navigate to={localStorage.getItem('orbitLastPath') || '/'} />
          }
        />
      </Routes>
    </div>
  );
};

export default Validation;
